export * from "../../base/store/getters";

export function accepted_file_types(state) {
	return state.accepted_file_types;
}
